import React from 'react'
import {
    Box,
    VStack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {GoBackIcon} from '../../../components/icons/action'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import SanitizedHtml from '../../../components/html-sanitizer'

// HOOKS
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

//utils
import routingObject from '../../../utils/static-routes'
export default function GoBackButton({
    goBackText = 'default',
    goBackToPath = routingObject.FAQ_PATH,
}) {
    const navigate = useNavigation()
    const styles = useMultiStyleConfig('Faq', {})
    const {goBackButtonStyles} = styles || null
    let defaultMessage = (
        <FormattedMessage
            id="faq_page.go_back_button.go_to_categories_message"
            defaultMessage="Categories"
        />
    )

    let specialCase = (
        <SanitizedHtml as={Text} html={goBackText} {...goBackButtonStyles?.goBackText} />
    )
    let defaultCase = <Text {...goBackButtonStyles?.goBackText}>{defaultMessage}</Text>

    const handleGoBack = () => {
        navigate(goBackToPath)
    }

    return (
        <VStack {...goBackButtonStyles?.outerContainer}>
            <Box {...goBackButtonStyles?.buttonWrapper} onClick={handleGoBack}>
                <Box {...goBackButtonStyles?.iconWrapper}>
                    <GoBackIcon flexShrink="0" data-testid="goBackIcon" />
                </Box>
                {goBackText === 'default' ? defaultCase : specialCase}
            </Box>
        </VStack>
    )
}

GoBackButton.propTypes = {
    goBackText: PropTypes.string,
    goBackToPath: PropTypes.string,
}
